define('notifications/downgrade-notification/downgrade-notification',['require','exports','module','mixpanel-helper','knockout','plugins/dialog','api-access'],function (require, exports, module) {
    var mixpanelHelper = require('mixpanel-helper');
    var ko = require('knockout');
    var dialog = require('plugins/dialog');
    var user = require('api-access').user;

    module.exports = function () {
        var self = this;

        // admins (billing and non billing) get different messaging
        self.isAdmin = ko.observable();

        self.show = function () {
            mixpanelHelper.track('Downgrade Notification: Show');
            user.updateSettings({downgradeNotificationViewed: true});
            return dialog.show(this);
        };

        self.dismiss = function () {
            mixpanelHelper.track('Downgrade Notification: Dismiss');
            dialog.close(self);
        };
    };
});

